import { render, staticRenderFns } from "./AdminTrainingBrandProductList.vue?vue&type=template&id=1bcca510"
import script from "./AdminTrainingBrandProductList.vue?vue&type=script&lang=js"
export * from "./AdminTrainingBrandProductList.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainingBrandProductList.vue?vue&type=style&index=0&id=1bcca510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports